import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Beranda chat anonim ${ctx.brand}`,
    languageButtonLabel: `Bahasa`,
    languageModalTitle: `Pilih bahasa`,
    languageModalCloseLabel: `Tutup menu bahasa`,
  },
  languageOptions: {
    'en-US': {
      label: `Inggris (Amerika Serikat)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Inggris (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Inggris (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Inggris (Singapura)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugis (Portugal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portugis (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Jerman (Jerman)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Jerman (Austria)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Jerman (Swiss)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spanyol (Spanyol)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Prancis (Prancis)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italia (Italia)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Belanda (Belanda)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski (Polandia)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Swedia (Swedia)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk (Denmark)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi (Finlandia)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norwegia (Norwegia)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Islandia (Islandia)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Jepang (Jepang)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Korea (Korea Selatan)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Tionghoa (Tiongkok)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kanton (Hong Kong DAK Tiongkok)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnam (Vietnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thai (Thailand)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonesia (Indonesia)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Swahili (Kenya)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi (India)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengali (Bangladesh)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi (India)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu (India)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persia (Iran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Punjabi (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Pidgin Nigeria (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Rusia (Rusia)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arab (Arab Saudi)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arab (Uni Emirat Arab)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arab (Qatar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Arab Maroko (Maroko)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Turki (Turki)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Pilih bahasa`,
    closeLabel: `Tutup menu bahasa`,
  },
  languageHint: (ctx) => `Loncat ke ${ctx.localesCount}+ bahasa tanpa bikin akun.`,
  readPagePrompt: ({languageLabel}) => `Baca halaman ini dalam ${languageLabel}.`,
};
